import Stamp1 from '../icon/stamp1.svg';
import Stamp2 from '../icon/stamp2.svg';
import Stamp3 from '../icon/stamp3.svg';
import Stamp4 from '../icon/stamp4.svg';
import Stamp5 from '../icon/stamp5.svg';

export const stampData = [
  {
    id: 'stamp1',
    image: Stamp1,
    alt: 'stamp_1',
  },
  {
    id: 'stamp2',
    image: Stamp2,
    alt: 'stamp_2',
  },
  {
    id: 'stamp3',
    image: Stamp3,
    alt: 'stamp_3',
  },
  {
    id: 'stamp4',
    image: Stamp4,
    alt: 'stamp_4',
  },
  {
    id: 'stamp5',
    image: Stamp5,
    alt: 'stamp_5',
  },
];
